<template>
  <chart v-if="!loading" ref="chart" :options="chartOptions" />
</template>
<script>
import { Chart } from 'highcharts-vue'
import operationService from '@/services/api/operationService'

export default {
  components: {
    Chart,
  },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      chartOptions: {
        chart: {
          type: 'column',
          height: 250,
          backgroundColor: 'transparent',
        },
        title: {
          text: 'História',
        },
        xAxis: {
          categories: {},
          visible: false,
          reversed: true,
        },
        yAxis: {
          title: {
            text: '',
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: null,
          valueSuffix: ` ${this.$parent.getUnit()}`,
        },
        legend: {
          reversed: true,
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'podruzne-meradla_historia',
        },
      },
      prevYearsData: [],
    }
  },
  computed: {
    selectedIds() {
      return this.data.map((i) => i.device.serialNumber)
    },
    year() {
      return parseInt(this.$route.query.year)
    },
    prevYearsChartData() {
      let output = []
      for (let prev of this.prevYearsData) {
        let data = this.selectedIds.map((sn) =>
          prev.data.find((i) => i.serialNumber == sn),
        )
        output.push({
          year: prev.year,
          data: data.map((i) => (i ? i.consumption : null)),
        })
      }
      return output
    },
    currentYearChartData() {
      return [{ year: this.year, data: this.data.map((i) => i.consumption) }]
    },
    chartData() {
      let data = [...this.currentYearChartData, ...this.prevYearsChartData]
      return data.map((item) => {
        return {
          name: item.year,
          data: item.data,
        }
      })
    },
  },
  watch: {
    data() {
      this.chartUpdate()
    },
  },
  created() {
    this.loading = true
    Promise.all([this.getHistoryData(1), this.getHistoryData(2)]).then(
      (res) => {
        this.loading = false
        res.forEach((i) => {
          if (i.data) {
            this.prevYearsData.push({
              year: i.year,
              data: i.data.map((row) => ({
                id: row.id,
                serialNumber: row.device.serialNumber,
                consumption: row.consumption,
                name: row.device.name,
                date: row.periodFrom,
              })),
            })
          }
        })
        this.chartUpdate()
      },
    )
  },
  methods: {
    getHistoryData(y) {
      let month = this.$moment(this.$route.query.month, 'MM').format('MM')
      let periodFrom = `${this.year - y}-${month}`
      let periodTo = `${this.year - y}-${month}`

      return operationService
        .getDeviceDataByDeliveryPointId(
          this.$store.getters['operation/get'].callback_id,
          {
            periodFrom: {
              ge: this.$moment(periodFrom, 'YYYY-MM')
                .startOf('month')
                .format('YYYY-MM-DD'),
            },
            periodTo: {
              le: this.$moment(periodTo, 'YYYY-MM')
                .endOf('month')
                .format('YYYY-MM-DD'),
            },
          },
        )
        .then((res) => {
          return { data: res.data, year: this.year - y }
        })
    },
    chartUpdate() {
      this.chartOptions.series = this.chartData
      this.chartOptions.xAxis.categories = this.data.map((item) => {
        return item.device.name
      })
    },
  },
}
</script>
